import React from "react";

const NoMeasures = () => {
  return (
    <div className="no-measures">
      <p className="uk-text-center">
        Empty (no measures) <span>😔</span>
      </p>
    </div>
  );
};

export default NoMeasures;
